<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>会员</el-breadcrumb-item>
        <el-breadcrumb-item>实体卡管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary"  size="small" class="el-icon-circle-plus-outline" v-on:click="AddMemberCardBatch" >新增</el-button>
        </el-form-item>         
        <el-form-item >
          <el-input  placeholder="名称"  size="small" v-model="queryParam.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  size="small" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="memberCardBatchs" style="width: 100%">
        <el-table-column  prop="BillNumber"  label="编号"> </el-table-column>
        <el-table-column  prop="StoreName" :show-overflow-tooltip="true" label="所属门店"></el-table-column>
        <el-table-column  prop="MeberCardName"  label="会员卡"> </el-table-column>
        <el-table-column  prop="BeginCardNo"  label="开始卡号"> </el-table-column>
        <el-table-column  prop="EndCardNo"  label="结束卡号"> </el-table-column>
        <el-table-column  prop="TotalCount" width="100px" label="总数量"> </el-table-column>
        <el-table-column  prop="UsedCount" width="100px"  label="使用数量"> </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="Export(scope.row.Id)" type="text" size="small">
              导出
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>   
    <el-dialog title="发卡" width="420px" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="memberCardBatch" label-width="100px" size="medium">       
        <el-form-item label="所属店铺">        
          <el-col :span="17">
            <el-input v-model="storeName" readonly placeholder="名称">
              <el-button  slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
            </el-input>
          </el-col>       
        </el-form-item>
        <el-form-item label="会员卡">        
          <el-col :span="17">
          <el-select v-model="memberCardBatch.memberCardId" placeholder="请选会员卡">
            <el-option
              v-for="item in memberCards"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>  
          </el-col>            
        </el-form-item>
         <el-form-item label="起始卡号">
          <el-col :span="17">            
            <el-tooltip class="item" effect="dark" content="卡号长度8-10位" placement="right">
              <el-input placeholder="卡号长度8-10位" v-model="memberCardBatch.beginCardNo"></el-input>
            </el-tooltip>
          </el-col>
        </el-form-item>
         <el-form-item label="结束卡号">
          <el-col :span="17">
            <el-input placeholder="卡号长度8-10位" v-model="memberCardBatch.endCardNo"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="MakeMemberCard">确 定</el-button>
      </div>
    </el-dialog>    
    <GetChainStore v-bind:dialogStore="dialogStore" @UpdateSote="UpdateSote"></GetChainStore> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import GetChainStore from '@/components/GetChainStore'
  export default {
    props:{
    },
    data (){
      return {        
        memberCardBatchs:[],
        queryParam:{
          name:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          totalPage:1,
          sort:' OperateTime desc ',
        },
        memberCards:[],
        memberCardBatch:{
          chainStoreId:'',
          memberCardId:'',
          beginCardNo:'',
          endCardNo:'',
        },
        storeName:'',
        dialogStore:{
          isShow:false
        },
        dialogFormVisible:false
      }
    },
    computed:{
    },
    mounted(){
      this.MemberCardBatchQuery();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.MemberCardBatchQuery();
      },
      AddMemberCardBatch:function(){
        this.memberCardBatch.chainStoreId=''
        this.memberCardBatch.memberCardId=''
        this.memberCardBatch.beginCardNo=''
        this.memberCardBatch.endCardNo=''
        this.dialogFormVisible= true
      },
      MemberCardBatchQuery:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/MemberCard/BatchIndex',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.memberCardBatchs = resp.data.memberCardBatchs
          that.chainStores = resp.data.chainStores
          that.memberCards = resp.data.memberCards
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      EditMemberCard(index, rows){
       
      },
      MakeMemberCard(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/MemberCard/MakeCard',         
          data:that.memberCardBatch
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.dialogFormVisible = false
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1
        this.MemberCardBatchQuery()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.MemberCardBatchQuery()
      },
      selectStoreHandle:function(){
        this.dialogStore.isShow = true
      },
      Export:function(id){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/MemberCard/Export',         
          data:{id:id},
          responseType: 'blob'
        }).then(function (res) {
          debugger
          const link = document.createElement('a')
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.setAttribute('download', `制卡列表.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      UpdateSote:function(id,name){
        this.memberCardBatch.chainStoreId = id 
        this.storeName = name 
      }
    },
    components:{    
      GetChainStore
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>